import React from 'react';
import { motion } from 'framer-motion';
import {
  Users, BookOpen, Eye, CreditCard, TrendingUp,
  Crown, Clock, Trash2, Shield, ShieldOff, BarChart3,
  Link2, Percent, Euro, Plus, Copy, Check as CheckIcon, X,
  Ban, UserCheck, Gift, CalendarPlus, Download, History, MoreVertical, Mail, Send, Tag
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../ui/dropdown-menu';

export const OverviewTab = ({ ctx }) => {
  const { stats, topStories, handleToggleFree, setShowDeleteAllDialog } = ctx;
  return (
  <TabsContent value="overview" className="space-y-6">
              <Card className="border-0 shadow-sm">
                <CardHeader>
                  <CardTitle className="text-lg font-semibold flex items-center gap-2">
                    <TrendingUp className="w-5 h-5 text-gold" />
                    Top 10 Verhalen
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {topStories.length === 0 ? (
                    <p className="text-muted-foreground text-center py-8">Nog geen gelezen verhalen</p>
                  ) : (
                    <div className="space-y-3">
                      {topStories.map((story, index) => (
                        <div 
                          key={story.id}
                          className="flex flex-col sm:flex-row sm:items-center justify-between p-3 rounded-xl bg-muted/30 hover:bg-muted/50 transition-colors gap-2"
                        >
                          <div className="flex items-center gap-3 min-w-0">
                            <span className={`w-7 h-7 rounded-lg flex items-center justify-center font-semibold text-xs shrink-0 ${
                              index < 3 ? 'bg-gold/10 text-gold' : 'bg-muted text-muted-foreground'
                            }`}>
                              {index + 1}
                            </span>
                            <div className="min-w-0">
                              <div className="flex items-center gap-1.5 flex-wrap">
                                <p className="font-medium text-sm truncate">{story.title}</p>
                                {story.is_free ? (
                                  <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full shrink-0">Gratis</span>
                                ) : (
                                  <span className="text-[10px] bg-gold/10 text-gold px-1.5 py-0.5 rounded-full flex items-center gap-0.5 shrink-0">
                                    <Crown className="w-2.5 h-2.5" /> Premium
                                  </span>
                                )}
                              </div>
                              <p className="text-xs text-muted-foreground">door {story.grandma_name}</p>
                            </div>
                          </div>
                          <div className="flex items-center gap-2 ml-10 sm:ml-0 shrink-0">
                            <div className="flex items-center gap-1 text-muted-foreground text-xs">
                              <Eye className="w-3.5 h-3.5" />
                              <span>{story.read_count?.toLocaleString() || 0}</span>
                            </div>
                            <Button
                              size="sm"
                              variant={story.is_free ? "outline" : "default"}
                              onClick={() => handleToggleFree(story.id)}
                              className={`rounded-full text-[10px] px-2 h-7 ${story.is_free ? '' : 'bg-green-600 hover:bg-green-700 text-white'}`}
                              data-testid={`toggle-free-${story.id}`}
                            >
                              {story.is_free ? 'Premium' : 'Gratis'}
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={async () => {
                                if (window.confirm(`"${story.title}" verwijderen?`)) {
                                  try {
                                    await axios.delete(`${API}/stories/${story.id}`, { headers: { Authorization: `Bearer ${token}` } });
                                    toast.success('Verhaal verwijderd');
                                    fetchData();
                                  } catch (e) {
                                    toast.error(e.response?.data?.detail || 'Verwijderen mislukt');
                                  }
                                }
                              }}
                              className="rounded-full text-destructive border-destructive/20 hover:bg-destructive/10 h-7 w-7 p-0"
                              data-testid={`delete-story-${story.id}`}
                            >
                              <Trash2 className="w-3 h-3" />
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            </TabsContent>
  );
};
